module.exports = __webpack_public_path__ + "img/xlogo.eff48420.png";